import React from 'react';
import {Route, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {toggleCollapsedNav} from 'actions/index';
import {NotificationContainer} from 'react-notifications';
import LoginPage from './routes/appModule/routes/login/Login2'
import RegisterPage from './routes/appModule/routes/signUp/StepperRegister'

import {isIOS, isMobile} from 'react-device-detect';


import {create} from 'jss';
import rtl from 'jss-rtl';
import JssProvider from 'react-jss/lib/JssProvider';
import {createGenerateClassName, jssPreset} from '@material-ui/core/styles';
import Loading from './loading';


// Configure JSS
const jss = create({plugins: [...jssPreset().plugins, rtl()]});

// Custom Material-UI class name generator.
const generateClassName = createGenerateClassName();


class login extends React.Component {
    onToggleCollapsedNav = (e) => {
        const val = !this.props.navCollapsed;
        this.props.toggleCollapsedNav(val);
    };


    constructor(props) {
        super(props);

        //this.handleLoading = this.handleLoading.bind(this);

        this.state = {
            loading: true
        }
    }

    /*handleLoading(show) {
        this.setState({loading: show});
    }*/

    render() {

        const {match} = this.props;
        const {loading} = this.state;

        //set default height and overflow for iOS mobile Safari 10+ support.
        if (isIOS && isMobile) {
            $('#body').addClass('ios-mobile-view-height')
        }
        else if ($('#body').hasClass('ios-mobile-view-height')) {
            $('#body').removeClass('ios-mobile-view-height')
        }

        return (
            <JssProvider jss={jss} generateClassName={generateClassName}>
                <main className="app-main-content-wrapper">
                    <div className="app-main-content login-main-content">
                        <Route path={`${match.url}/accounthandler/login`} component={LoginPage}/>
                        <Route path={`${match.url}/accounthandler/register`} component={RegisterPage}/>
                        {/*{loading && <Loading/>}
                        <Route path={`${match.url}/accounthandler/login`}
                               render={(props) => {
                                   let prop = Object.assign({}, {...props}, {handleLoading: this.handleLoading})
                                   return (<LoginPage {...prop}/>);
                               }}/>
                        <Route path={`${match.url}/accounthandler/register`}
                               render={(props) => {
                                   let prop = Object.assign({}, {...props}, {handleLoading: this.handleLoading})
                                   return (<RegisterPage {...prop}/>);
                               }}/>*/}
                    </div>
                    <NotificationContainer/>
                </main>
            </JssProvider>
        );

    }
}


const mapStateToProps = ({settings}) => {
    const {navCollapsed, drawerType} = settings;
    return {navCollapsed, drawerType}
};
export default withRouter(connect(mapStateToProps, {toggleCollapsedNav})(login));



// WEBPACK FOOTER //
// ./app/login.js